import React from "react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher.tsx";
import type { LegalPageKind } from "./LegalPage.tsx";

interface SiteFooterProps {
  onOpenLegal: (_kind: LegalPageKind) => void;
  variant?: "landing" | "app";
}

const FONT =
  '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

const linkStyle: React.CSSProperties = {
  background: "transparent",
  border: "none",
  color: "rgba(255,255,255,0.7)",
  cursor: "pointer",
  textDecoration: "underline",
  textUnderlineOffset: "3px",
  padding: 0,
  fontSize: "13px",
  fontFamily: FONT,
};

const SiteFooter: React.FC<SiteFooterProps> = ({
  onOpenLegal,
  variant = "landing",
}) => {
  const { t } = useTranslation();
  return (
    <footer
      style={{
        padding: variant === "app" ? "32px 24px 16px 24px" : "32px 24px",
        textAlign: "center",
        color: "rgba(255,255,255,0.5)",
        fontSize: "13px",
        fontFamily: FONT,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "12px",
        maxWidth: "1100px",
        margin: "0 auto",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "16px",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <button type="button" onClick={() => onOpenLegal("imprint")} style={linkStyle}>
          {t("nav.imprint")}
        </button>
        <span style={{ opacity: 0.4 }}>·</span>
        <button type="button" onClick={() => onOpenLegal("privacy")} style={linkStyle}>
          {t("nav.privacy")}
        </button>
        <span style={{ opacity: 0.4 }}>·</span>
        <LanguageSwitcher />
      </div>
      <div>{t("landing.footer.tagline")}</div>
      <div style={{ opacity: 0.7, fontSize: "12px" }}>
        © {new Date().getFullYear()} Twylo LLC · Sheridan, WY · USA
      </div>
    </footer>
  );
};

export default SiteFooter;
